const apiUrl = process.env.VUE_APP_API_BASEURL;

export default {
  commune: `${apiUrl}/v2/commune`,
  communeById: (id: string) => `${apiUrl}/v2/commune/${id}`,
  discountForTaxcard: (id: string) => `${apiUrl}/v2/commune/${id}/discount`,
  annualCandidateStatusForTaxcard: (id: string) => `${apiUrl}/v2/commune/${id}/annualCandidate`,
  findCommuneByCoordinates: (latitude: string, longitude: string) =>
    `${apiUrl}/v2/locate/commune?lat=${latitude}&lng=${longitude}`,
  communeAccepts: (communeId: number, acceptsId: number) => `${apiUrl}/v2/commune/${communeId}/accepts/${acceptsId}`,
  acceptedCommunes: (communeId: number) => `${apiUrl}/v2/commune/${communeId}/accepts`,
  cancelTransaction: (id: number, customerUUID?: string) =>
    `${apiUrl}/v2/commune/transaction/cancel/${id}${customerUUID && `/${customerUUID}`}`,
  communeDetails: (id: number, customerUUID?: string) => `${apiUrl}/v2/commune/${id}/details/${customerUUID}`,
};
